/* Persona: on touch screens, a touched product card shows its second image.
   It stays for at least HOLD ms, or for as long as the finger stays on it. */
(function () {
  if (window.__pcSlide) return;
  window.__pcSlide = true;
  if (!window.matchMedia('(hover: none)').matches) return;

  var HOLD = 3000;
  var active = null;

  function cardAt(x, y) {
    var el = document.elementFromPoint(x, y);
    var card = el && el.closest('.card-wrapper');
    return card && card.querySelector('.media.pc-slide') ? card : null;
  }
  function show(card) {
    clearTimeout(card.__pcT);
    card.__pcStart = Date.now();
    card.classList.add('pc-on');
  }
  function release(card) {
    var left = Math.max(0, HOLD - (Date.now() - card.__pcStart));
    clearTimeout(card.__pcT);
    card.__pcT = setTimeout(function () { if (card !== active) card.classList.remove('pc-on'); }, left);
  }
  function set(card) {
    if (card === active) return;
    var prev = active;
    active = card;
    if (prev) release(prev);
    if (card) show(card);
  }
  function fromTouch(e) {
    var t = e.touches && e.touches[0];
    if (t) set(cardAt(t.clientX, t.clientY));
  }

  document.addEventListener('touchstart', fromTouch, { passive: true });
  document.addEventListener('touchmove', fromTouch, { passive: true });
  document.addEventListener('touchend', function () { set(null); }, { passive: true });
  document.addEventListener('touchcancel', function () { set(null); }, { passive: true });
})();
